import { render, staticRenderFns } from "./VoiceMessage.vue?vue&type=template&id=8477ec12&scoped=true"
import script from "./VoiceMessage.vue?vue&type=script&lang=js"
export * from "./VoiceMessage.vue?vue&type=script&lang=js"
import style0 from "./VoiceMessage.vue?vue&type=style&index=0&id=8477ec12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8477ec12",
  null
  
)

export default component.exports